import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Index from "@/pages/Index";
import Auth from "@/pages/Auth";
import ClientInfo from "@/pages/ClientInfo";
import MainDashboard from "@/pages/MainDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import WelcomeDashboard from "@/pages/WelcomeDashboard";
import Settings from "@/pages/Settings";
import ClientDirectory from "@/pages/ClientDirectory";
import Generate from "@/pages/Generate";
import GeneratedContent from "@/pages/GeneratedContent";
import ManageClientCategories from "@/pages/ManageClientCategories";
import ManagePrompts from "@/pages/ManagePrompts";
import ManageUsers from "@/pages/ManageUsers";
import PromptHistory from "@/pages/PromptHistory";
import ManageFields from "@/pages/ManageFields";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import BaseLayout from "@/layouts/BaseLayout";
import ManageBetaTesters from "./pages/ManageBetaTesters";

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <BaseLayout>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/client-info" element={<ClientInfo />} />
            <Route path="/dashboard" element={<MainDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/welcome" element={<WelcomeDashboard />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/client-directory" element={<ClientDirectory />} />
            <Route path="/generate" element={<Generate />} />
            <Route path="/generated-content" element={<GeneratedContent />} />
            <Route path="/manage-client-categories" element={<ManageClientCategories />} />
            <Route path="/manage-prompts" element={<ManagePrompts />} />
            <Route path="/manage-users" element={<ManageUsers />} />
            <Route path="/prompt-history" element={<PromptHistory />} />
            <Route path="/manage-fields" element={<ManageFields />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/manage-beta-testers" element={<ManageBetaTesters />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BaseLayout>
        <Toaster />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
